import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_ddd_3097_30439)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10 2C6.13401 2 3 5.13401 3 9V23C3 26.866 6.13401 30 10 30H24C27.866 30 31 26.866 31 23V9C31 5.13401 27.866 2 24 2H10ZM14.375 7.25C17.2745 7.25 19.625 9.60051 19.625 12.5V23.875C19.625 24.3582 19.2332 24.75 18.75 24.75C15.8505 24.75 13.5 22.3995 13.5 19.5C13.5 19.2584 13.3041 19.0625 13.0625 19.0625H12.25C9.55761 19.0625 7.375 16.8799 7.375 14.1875C7.375 13.7388 7.73877 13.375 8.1875 13.375H12.625C13.1082 13.375 13.5 12.9832 13.5 12.5V8.125C13.5 7.64175 13.8918 7.25 14.375 7.25ZM26.625 16.4375C26.625 18.1289 25.2539 19.5 23.5625 19.5C21.8711 19.5 20.5 18.1289 20.5 16.4375C20.5 14.7461 21.8711 13.375 23.5625 13.375C25.2539 13.375 26.625 14.7461 26.625 16.4375Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_ddd_3097_30439",
			x: 0,
			y: 0,
			width: 34,
			height: 34,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_3097_30439"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_3097_30439",
					result: "effect2_dropShadow_3097_30439"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect2_dropShadow_3097_30439",
					result: "effect3_dropShadow_3097_30439"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect3_dropShadow_3097_30439",
					result: "shape"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
